import { useState, useEffect } from "react";
import { PropertyVideoUpload } from "../PropertyVideoUpload";
import { useToast } from "@/hooks/use-toast";

interface PropertyVideoTabProps {
  propertyId: string;
  currentVideoUrl: string | null;
  currentThumbnailUrl?: string | null;
  onVideoUpdated: () => void;
}

export const PropertyVideoTab = ({
  propertyId,
  currentVideoUrl,
  currentThumbnailUrl,
  onVideoUpdated
}: PropertyVideoTabProps) => {
  const { toast } = useToast();
  const [videoUrl, setVideoUrl] = useState(currentVideoUrl);
  const [thumbnailUrl, setThumbnailUrl] = useState(currentThumbnailUrl);

  // Sync local state with prop changes
  useEffect(() => {
    setVideoUrl(currentVideoUrl);
    setThumbnailUrl(currentThumbnailUrl);
  }, [currentVideoUrl, currentThumbnailUrl]);

  const handleVideoUploaded = (url: string) => {
    setVideoUrl(url);
    onVideoUpdated();
    toast({
      title: "Video uploaded",
      description: "Property video has been successfully uploaded",
    });
  };

  const handleVideoRemoved = () => {
    setVideoUrl(null);
    setThumbnailUrl(null);
    onVideoUpdated();
    toast({
      title: "Video removed",
      description: "Property video has been removed",
    });
  };

  return (
    <div className="space-y-6">
      <PropertyVideoUpload
        propertyId={propertyId}
        currentVideoUrl={videoUrl}
        onVideoUploaded={handleVideoUploaded}
        onVideoRemoved={handleVideoRemoved}
      />
    </div>
  );
};
